import { useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";

import { ChevronDown, Grid, Layout, MoreVertical } from "react-feather";
import { useParams } from "react-router";
import { GET_SERVICES_BY_ORGANIZATION_ID } from "../../../shared/queries";
import { Badge } from "../../atoms/Buttons";
import { H4, P } from "../../atoms/Texts";
import EditEligibilityModal from "../EditEligibilityModal";

export const EligibilityTable = ({ eligibilities, services }) => {
  const [showEditEligibilityModal, setShowEditEligibilityModal] = useState(false);
  const toggleModal = () => setShowEditEligibilityModal(!showEditEligibilityModal);
  const [selectedEligibility, setSelectedEligibility] = useState({});

  const { id } = useParams();

  return (
    <div>
      <div className="p-8 flex justify-between items-center">
        <H4 fontFamily="regular">Eligibility Criteria</H4>
        <div className="flex items-center">
          <Layout className="mr-5" color="#413E53" size={20} />
          <Grid className="mr-5" color="#413E53" size={20} />
          <P
            fontSize="14px"
            className="border-l-2 pl-5 border-black font-medium mr-5"
          >
            Relevance
          </P>
          <ChevronDown color="#413E53" />
        </div>
      </div>
      <div className="w-full mb-8 overflow-hidden rounded-lg">
        <table className="w-full">
          <thead>
            <tr className="tracking-wide text-left text-gray-600 ">
              <th className="px-8 py-3">Services</th>
              <th className="px-8 py-3">Situations</th>
              <th className="px-8 py-3">Autoscreen</th>
              <th className="px-8 py-3"></th>
            </tr>
          </thead>
          <tbody className="bg-white border-t">
            {eligibilities?.map((eligibility) => (
              <tr className="text-gray-700 border-b" key={eligibility.id}>
                <td className="px-8 py-3">
                  <Badge
                    className="mr-2 cursor-default"
                    w="contain"
                    bg="#ECE9FF"
                    fontSize="14px"
                  >
                    {eligibility?.service?.name}
                  </Badge>
                </td>
                <td className="px-8 py-3">
                  {eligibility?.situation?.split(",")?.map((situation) => (
                    <Badge
                      className="truncate mr-2 cursor-default"
                      w="100px"
                      bg="#ECE9FF"
                      fontSize="14px"
                      key={situation}
                    >
                      {situation}
                    </Badge>
                  ))}
                </td>
                <td className="px-8 py-3 text-sm">
                  {eligibility.autoScreen ? "Yes" : "No"}
                </td>
                <td className="px-8 py-3 text-sm">
                  <div>
                    <MoreVertical
                      className="cursor-pointer"
                      onClick={() => {
                        setSelectedEligibility(eligibility);
                        toggleModal();
                      }}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showEditEligibilityModal && (
        <EditEligibilityModal
          services={services}
          closeModal={toggleModal}
          eligibility={selectedEligibility}
        />
      )}
    </div>
  );
};
